import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-ee",
  "use": "icon-icon-ee-usage",
  "viewBox": "0 0 512 512",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 512 512\" id=\"icon-icon-ee\">\n  <g fill-rule=\"evenodd\" stroke-width=\"1pt\" transform=\"scale(.482 .72)\">\n    <rect width=\"1063\" height=\"708.7\" rx=\"0\" ry=\"0\" />\n    <rect width=\"1063\" height=\"236.2\" y=\"475.6\" fill=\"#fff\" rx=\"0\" ry=\"0\" />\n    <path fill=\"#1791ff\" d=\"M0 0h1063v236.2H0z\" />\n  </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol